/**
 * First character for avatar-style initials, uppercased.
 * Tries each candidate in order (trimmed); falls back to "?".
 */
export function getDisplayInitial(
  ...candidates: (string | null | undefined)[]
): string {
  for (const part of candidates) {
    const s = part?.trim();
    if (s) return s.charAt(0).toUpperCase();
  }
  return "?";
}

/**
 * Initials from the first two words, uppercased.
 */
export function getInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}
